// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"a1255f78","404":"de9e5a83","513":"6b2f6dc5","787":"67fd6f5a"}[chunkId] + ".chunk.js";
};